if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Adding to the real cart while just previewing the theme in the
        // Customizer would be confusing (and the section re-renders on every
        // settings change anyway), so skip wiring this up in design mode.
        if (window.Shopify && window.Shopify.designMode) return;

        this.lastSize = (this.dataset.lastSize || '').trim().toLowerCase();
        this.matchSizes();
        this.querySelectorAll('[data-upsell-add]').forEach((button) => {
          button.addEventListener('click', this.onAddClick.bind(this));
        });
      }

      // Reads the size of the most recently added cart item (server-rendered
      // into data-last-size) and, for each recommended product, pre-selects
      // the variant sharing that exact size when it's in stock. Falls back
      // to the product's default variant otherwise.
      matchSizes() {
        this.querySelectorAll('.cart-upsell__item').forEach((item) => {
          const variantsScript = item.querySelector('[data-upsell-variants]');
          const button = item.querySelector('[data-upsell-add]');
          const sizeLabel = item.querySelector('[data-upsell-size-label]');
          const addLabel = item.querySelector('[data-upsell-add-label]');
          if (!variantsScript || !button) return;

          let variants = [];
          try {
            variants = JSON.parse(variantsScript.textContent);
          } catch (error) {
            return;
          }

          let matched = null;
          if (this.lastSize) {
            matched = variants.find(
              (variant) => variant.available && (variant.size || '').trim().toLowerCase() === this.lastSize
            );
          }

          const chosen = matched || variants.find((variant) => variant.available) || variants[0];
          if (!chosen) return;

          button.dataset.variantId = chosen.id;
          button.toggleAttribute('disabled', !chosen.available);

          if (addLabel) addLabel.textContent = `Añadir ${this.formatMoney(chosen.price)}`;
          if (sizeLabel) {
            sizeLabel.hidden = !matched;
            if (matched) sizeLabel.textContent = `Talla ${matched.size}`;
          }
        });
      }

      formatMoney(cents) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
      }

      onAddClick(event) {
        const button = event.currentTarget;
        const variantId = button.dataset.variantId;
        if (!variantId || button.hasAttribute('disabled') || button.classList.contains('loading')) return;

        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        const spinner = button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          formData.append(
            'sections',
            cartDrawer.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(response.description || response.message);
              return;
            }

            if (cartDrawer) {
              cartDrawer.renderContents(response);
            } else {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: response });
            }
          })
          .catch((error) => console.error(error))
          .finally(() => {
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
